import styled from 'styled-components';

export const $DrawerHeader = styled.div`
  position: relative;
  margin-bottom: 1.25rem;
  padding-right: 2.5rem;
`;

export const $CloseButtonWrap = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const $StepTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 1rem;
  color: ${({ theme }) => theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#333'};
`;

export const $StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const $PathOption = styled.button`
  display: block;
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  font-size: 0.9375rem;
  background: ${({ theme }) =>
    theme.newUI?.variationColors?.light5 ?? theme.colors?.lightGrey ?? '#f5f5f5'};
  border: 1px solid
    ${({ theme }) =>
      theme.newUI?.variationColors?.light3 ?? theme.colors?.default ?? '#e0e0e0'};
  border-radius: ${({ theme }) =>
    theme.newUI?.borders?.mediumRadius ?? theme.borders?.radius ?? '6px'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#333'};
  cursor: pointer;
  transition:
    background-color 0.15s,
    border-color 0.15s;

  &:hover {
    background: ${({ theme }) => theme.newUI?.variationColors?.light4 ?? '#ebebeb'};
    border-color: ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    outline-offset: 2px;
  }
`;

export const $SelectedPathStrip = styled.div`
  padding: 10px 14px;
  margin-bottom: 1rem;
  font-size: 0.9375rem;
  background: ${({ theme }) =>
    theme.newUI?.variationColors?.light5 ?? theme.colors?.lightGrey ?? '#f5f5f5'};
  border-left: 3px solid ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
  border-radius: ${({ theme }) => theme.newUI?.borders?.smallRadius ?? '4px'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#333'};
`;

export const $SelectedPathLabel = styled.span`
  font-weight: 600;
  margin-right: 0.35rem;
`;

export const $BackButtonWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1rem;
`;

export const $BackButton = styled.button`
  padding: 0;
  font-size: 0.875rem;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const $PathPlaceholder = styled.div`
  margin-top: 0.5rem;
  padding: 1rem;
  border: 1px dashed
    ${({ theme }) => theme.newUI?.inputBorderColors?.default ?? '#cbd5e1'};
  border-radius: ${({ theme }) => theme.newUI?.borders?.mediumRadius ?? '8px'};
  background: ${({ theme }) => theme.newUI?.variationColors?.light5 ?? '#f8fafc'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.secondaryText ?? theme.colors?.paragraphTextColor ?? '#64748b'};
  font-size: 0.875rem;
  line-height: 1.45;
`;

export const $PathPlaceholderHint = styled.p`
  margin: 0 0 0.75rem;
`;

export const $PathPlaceholderIntegration = styled.p`
  margin: 0;
  font-size: 0.8125rem;
  font-style: italic;
`;
